import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const EMPTY = { makers: [], colors: [], materials: [], thread_types: [], base_types: [], names: [], countries: [], rarities: [] };

// Fetches the live, growing option lists for the creatable catalog dropdowns.
export function useCatalogOptions() {
  const [options, setOptions] = useState(EMPTY);
  useEffect(() => {
    let active = true;
    api.get("/insulators/meta/options")
      .then(({ data }) => { if (active) setOptions({ ...EMPTY, ...data }); })
      .catch(() => {});
    return () => { active = false; };
  }, []);
  return options;
}
